import { Injectable } from '@angular/core';
import { Resolve, Router } from '@angular/router';

import { catchError, map } from 'rxjs/operators';
import { ApiService } from './api.service';
import { AuthenticationService } from './authentication.service';

@Injectable({
  providedIn: 'root'
})
export class Auto123ResolverService implements Resolve<any>{

  constructor(
    private api: ApiService,
    private authService: AuthenticationService) { }

  resolve(route: import("@angular/router").ActivatedRouteSnapshot, state: import("@angular/router").RouterStateSnapshot) {

    this.authService.checkToken();

    return this.api.getToken().pipe(map(d => {
      this.authService.setAuth(d);
      return d;
    }), catchError(err => {
      return err;
    }));
  }

}


@Injectable({
  providedIn: 'root'
})
export class GtagsResolverService implements Resolve<any>{

  constructor() { }

  resolve(route: import("@angular/router").ActivatedRouteSnapshot) {

    let scriptSrc = "";
    let scriptJs = "";

    switch (route.routeConfig.path) {
      case "hogar":
        scriptSrc = "https://www.googletagmanager.com/gtag/js?id=UA-140956948-1";
        scriptJs = "assets/js/hogar.js";
        break;

      case "tecnologia":
      case "tecnologia-gracias":
      case "tecnologia-nps":
        scriptSrc = "https://www.googletagmanager.com/gtag/js?id=AW-614010822";
        scriptJs = "assets/js/tecno.js";
        break;
    }


    let scriptTag = document.createElement('script');
    scriptTag.src = scriptSrc;
    scriptTag.async = true;
    document.head.appendChild(scriptTag);

    scriptTag = document.createElement('script');
    scriptTag.src = scriptJs;
    document.head.appendChild(scriptTag);

    return true;
  }


}
